import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";

import Login from "./Login";
import DashboardLayout from "./DashboardLayout";

import "bootstrap/dist/css/bootstrap.min.css";

// import Login from "./Login";
import UpdateProfile from "./UpdateProfile";
import FloorRooms from "./FloorRooms";
import FloorForm from "./FloorForm";
import FloorsRoomsBeds from "./FloorsRoomsBeds";
import ConfigurationSetUpCount from "./ConfigurationSetUpCounts";
import MaxFloorCountForm from "./MaxFloorCountForm";
import RoomMaxSetUp from "./RoomMaxSetUp";
import BedMaxCountForm from "./BedMaxCountForm";
import CreateRoomForm from "./CreateRoomForm";
import CreateAddRoomForm from "./CreateAddRoomForm";
import CreateBedForm from "./CreateBedForm";
import FloorRoomBedSelector from "./FloorRoomBedSelector";
import FloorRoomsList from "./FloorRoomsList";
import BedsListForm from "./BedsListFrom";
import PgOwnerRegistration from "./PgOwnerRegistration";
import UsersDashboard from "./UsersDashboard";
import UserRegistration from "./UserRegistration";
import UserBedBooking from "./UserBedBooking";
import UserPaymentForm from "./UserPaymentForm";
import AllAvailableBeds from "./AllAvailableBeds";
import AvailableBedViewDetails from "./AvailableBedViewDetails";
import RegistrationForUsers from "./publicUsersPages/RegistrationForUsers";
import BedBookingForUsers from "./publicUsersPages/BedBookingForUsers";
import UserCompleteBookingForm from "./UserCompleteBookingForm";
import TenantsAndGuests from "./TenantsAndGuests";
import UserDetails from "./UserDetails";
import UpdateUserDetails from "./UpdateUserDetails";
import PgWelcomePage from "./PgWelcomePage";
import FoodMenuPerDay from "./FoodMenuPerDay";
import FoodMenuList from "./FoodMenuList";
import ApplicationHeadOwners from "./application-admin-pages/ApplicationHeadOwners";
import ApplicationHeadDashboard from "./application-admin-pages/ApplicationHeadDashboard";
import CreateExecutor from "./application-admin-pages/CreateExecutor";
import ExecutorList from "./application-admin-pages/ExecutorList";
import Payments from "./publicUsersPages/Payments";
import TokenWatcher from "./TokenWatcher";
import ForgotPassword from "./ForgotPassword";
import ChangePassword from "./ChangePassword";
import UserPaymentForm1 from "./UserPaymentForm1";
import UserDashboard from "./userPages/UserDashboard";
import UserPaymentProcessing from "./userPages/UserPaymentProcessing";
import UserPaymentProcessing1 from "./userPages/UserPaymentProcessing1";
import UserPaymentGateway from "./userPages/UserPaymentGateway";
import PaymentSuccess from "./userPages/PaymentSuccess";
import ReferralList from "./ReferralList";
import PaymentPage from "./userPages/PaymentPage";
import PaymentMethod from "./userPages/PaymentMethod";
import UserPaymentDetails from "./userPages/UserPaymentDetails";
import UserBedDetails from "./userPages/UserBedDetails";
import OfflineCashPaymentDetails from "./userPages/OfflineCashPaymentDetails";
import UpdateFloorData from "./UpdateFloorData";
import UserPayPendingAmount from "./userPages/UserPayPendingAmount";
import ReadyToJoinUsers from "./ReadyToJoinUsers";
import UserLogin from "./usersDashboardPages/UserLogin";
import NewUserRegister from "./usersDashboardPages/NewUserRegister";
import PgOwnerRegistrationOtp from "./PgOwnerRegistrationOtp";
import ExcelSheetUploadDownload from "./ExcelSheetUploadDownload";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<FloorRooms />} />
        {/* Remove this line */}
        {/* <Route index element={<DashboardLayout />} /> */}
        <Route path="/floorRoomsBeds" element={<FloorsRoomsBeds />} />
        <Route path="/createfloors" element={<FloorForm />} />
        <Route
          path="/configurationSetUpCount"
          element={<ConfigurationSetUpCount />}
        />
        <Route path="/maxFloorCountForm" element={<MaxFloorCountForm />} />
        <Route path="/roomMaxSetUp" element={<RoomMaxSetUp />} />
        <Route path="/bedMaxCountForm" element={<BedMaxCountForm />} />
        <Route path="/createRoomForm" element={<CreateRoomForm />} />
        <Route path="/createAddRoomForm" element={<CreateAddRoomForm />} />
        <Route path="/createBedForm" element={<CreateBedForm />} />
        <Route
          path="/floorRoomBedSelector"
          element={<FloorRoomBedSelector />}
        />
        <Route path="/floorRoomsList" element={<FloorRoomsList />} />
        <Route path="/bedsListForm" element={<BedsListForm />} />
        <Route path="/pgOwnerRegistration" element={<PgOwnerRegistration />} />
        <Route path="/usersDashboard" element={<UsersDashboard />} />
        <Route path="/userRegistration" element={<UserRegistration />} />
        <Route path="/userBedBooking" element={<UserBedBooking />} />
        <Route path="/userPaymentForm" element={<UserPaymentForm />} />
        <Route path="/userPaymentForm1" element={<UserPaymentForm1 />} />

        <Route path="/allAvailableBeds" element={<AllAvailableBeds />} />
        <Route
          path="/availableBedViewDetails"
          element={<AvailableBedViewDetails />}
        />
        <Route
          path="/registrationForUsers"
          element={<RegistrationForUsers />}
        />
        <Route path="/bedBookingForUsers" element={<BedBookingForUsers />} />
        <Route
          path="/userCompleteBookingForm"
          element={<UserCompleteBookingForm />}
        />
        <Route path="/tenantsAndGuests" element={<TenantsAndGuests />} />
        <Route path="/userDetails/:registerId" element={<UserDetails />} />
        <Route path="/updateProfile" element={<UpdateProfile />} />
        <Route path="/pgWelcomePage" element={<PgWelcomePage />} />
        <Route path="/foodMenuPerDay" element={<FoodMenuPerDay />} />
        <Route path="/foodMenuList" element={<FoodMenuList />} />
        <Route path="/pgOwnersData" element={<ApplicationHeadOwners />} />
        <Route
          path="/applicationHeadDashboard"
          element={<ApplicationHeadDashboard />}
        />

        <Route path="/createExecutor" element={<CreateExecutor />} />

        <Route path="/executorList" element={<ExecutorList />} />

        <Route path="/paymentSetting" element={<Payments />} />

        <Route path="/tokenWatcher" element={<TokenWatcher />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/changePassword" element={<ChangePassword />} />

        <Route path="/usersDashboardPage" element={<UserDashboard />} />

        <Route
          path="/userPaymentProcessing"
          element={<UserPaymentProcessing />}
        />
        <Route
          path="/userPaymentProcessing1"
          element={<UserPaymentProcessing1 />}
        />
        <Route path="/paymentSuccess" element={<PaymentSuccess />} />
        <Route path="/userPaymentGateway" element={<UserPaymentGateway />} />
        <Route path="/referralList" element={<ReferralList />} />

        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/paymentMethod" element={<PaymentMethod />} />

        <Route
          path="/showUserPaymentDetails"
          element={<UserPaymentDetails />}
        />
        <Route path="/userBedDetails" element={<UserBedDetails />} />
        <Route
          path="/updateUserDetails/:registerId"
          element={<UpdateUserDetails />}
        />

        <Route
          path="/offlineCashPaymentDetails"
          element={<OfflineCashPaymentDetails />}
        />
        <Route path="/updateFloorData" element={<UpdateFloorData />} />
        <Route
          path="/userPayPendingAmount"
          element={<UserPayPendingAmount />}
        />
        <Route path="/readyToJoinUsers" element={<ReadyToJoinUsers />} />
        <Route path="/userLogin" element={<UserLogin />} />
        <Route path="/newUserRegister" element={<NewUserRegister />} />
        <Route path="/newUserRegister" element={<NewUserRegister />} />
        <Route
          path="/pgOwnerRegistrationOtp"
          element={<PgOwnerRegistrationOtp />}
        />

        <Route
          path="/excelSheetUploadDownload"
          element={<ExcelSheetUploadDownload />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
